import React, {Component} from 'react'
import {withTranslation} from "react-i18next";

import PseudoModal from "../_components/PseudoModal";
import {Container, StyledMedia} from "../styles/CommonStyler";
import {isMobileOnly} from "react-device-detect";
import {Header} from "../components/Header";
import Footer from "../components/Footer";
import {connect} from "react-redux";
import zoomConnectConfirmationImage from '../../public/logo/gist-zoom-auth-confirm-main.png'
import styled from "@emotion/styled";
import StyleVariables from "../styles/styles";

// STYLE ##########################################################
const sv = StyleVariables;

const ZoomConnectConfirmImage = styled('img')`
  max-width: 100%;
  display: block;
  margin-left: auto;
  margin-right: auto;
  border: 1px solid ${sv.colors.darkGray};
`;

// COMPONENT ##########################################################

class ZoomConnect extends Component {

    handleSubmit() {
        return window.location.replace(process.env.RAZZLE_ZOOM_INTEGRATION_AUTH);
    }

    isReconnect() {
        const {integrations} = this.props;
        const {zoom} = integrations;
        return ( zoom && zoom.reconnect );
    }

    render() {
        const {t} = this.props;

        return (
            <StyledMedia>
                <Container isMobile={isMobileOnly}>
                    <Header />
                    { !this.isReconnect() &&
                        PseudoModal({
                            title: t("Configure Zoom"),
                            messages: [
                              t("Connect to your Zoom account to create Gists for your meetings and web conferences."),
                              <ZoomConnectConfirmImage src={zoomConnectConfirmationImage} alt={'zoom-connect-confirm'}/>,
                              t("Choosing to Sign In to your Zoom Account below will take you to Zoom’s site to authorize Gist. Choose the “Authorize” option there to start creating Gists for your meetings."),
                            ],
                            cancelText: t("Cancel"),
                            submitText: t("Sign In to your Zoom Account"),
                            handleSubmit: this.handleSubmit,
                            handleCancel: () => this.props.history.goBack()
                        })
                    }

                    { this.isReconnect() &&
                        PseudoModal({
                            title: t("Order a Gist"),
                            messages: [
                                t("Uh oh! It looks like Gistify is no longer able to connect to your Zoom account."),
                                t("If you'd like to order new Gists from your Zoom recordings, you'll have to sign into your Zoom account again.")
                            ],
                            cancelText: t("Cancel"),
                            submitText: t("Sign In to your Zoom Account"),
                            handleSubmit: this.handleSubmit,
                            handleCancel: () => this.props.history.goBack()
                        })
                    }
                    <Footer />
                </Container>
            </StyledMedia>
        )
    }
}

function mapStateToProps(state){
    const {alert, integrations} = state;
    return {
        alert, integrations
    }
}

const connectedZoomConnect = withTranslation()(connect(mapStateToProps)(ZoomConnect));
export { connectedZoomConnect as ZoomConnect };
